<div class="bg-gray mt-5 py-lg-3">
  <div class="container">
    <div class="row">
      <div class="col-lg-5 px-0 px-lg-3 banner-description">
        <div class="banner-constructora position-relative h-100">
          <div class="logo-banner-constructora">
            <img
              [src]="
                profile.image || './assets/img/constructoras/logo-default.png'
              "
              alt=""
              style="width: auto; height: 100px"
              class="p-3"
            />
          </div>
          <img
            [src]="
              profile.banner
                ? profile.banner
                : './assets/img/constructoras/banner-constructora-1.jpg'
            "
            alt=""
            class="img-fluid img-banner-constructora h-100"
            [style]="
              profile.description?.length < 80
                ? 'aspect-ratio: 2'
                : 'aspect-ratio: 100/80'
            "
          />
        </div>
      </div>
      <div class="col-lg-7 mt-5 mt-lg-0 pt-5 pt-lg-0 px-4 px-lg-3 text-description">
        <div *ngIf="!profile.name" class="py-5 text-center">
          Cargando información, por favor espere un momento...
        </div>
        <div *ngIf="profile.name">
          <h2 class="font-weight-bold">
            {{ profile.name }}
            <a
              *ngIf="profile.canEdit"
              class="small text-red"
              [href]="'./usuario/perfil/' + slug"
            >
              <span class="small">
                <small> Editar <i class="far fa-edit"></i> </small>
              </span>
            </a>
          </h2>

          <div class="row mb-1 mb-lg-2">
            <div class="col-auto pr-0">
              <i class="far fa-building"></i>
            </div>
            <div class="col">
              <div class="description">
                {{ profile.description }}
              </div>
            </div>
          </div>

          <div class="row mb-1 mb-lg-2">
            <div class="col-auto pr-0">
              <i class="fas fa-map-marker-alt"></i>
            </div>
            <div class="col">
              <div *ngFor="let location of profile.locations">
                {{ location.address
                }}{{ location.city ? ", " + location.city : "" }}
              </div>
            </div>
          </div>

          <div class="row mb-1 mb-lg-2" *ngIf="profile.cellphones?.length > 0">
            <div class="col-auto pr-0">
              <i class="fas fa-mobile-alt"></i>
            </div>
            <div class="col">
              <div *ngFor="let cellphone of profile.cellphones" class="d-inline-block d-lg-block mr-3 mr-lg-0">
                <a href="tel:{{ cellphone }}" class="text-blue">
                  {{ cellphone }}
                </a>
              </div>
            </div>
          </div>

          <div class="row mb-1 mb-lg-2" *ngIf="profile.websites?.length > 0">
            <div class="col-auto pr-0">
              <i class="fas fa-globe"></i>
            </div>
            <div class="col">
              <div *ngFor="let website of profile.websites"  class="d-inline-block d-lg-block mr-3 mr-lg-0">
                <a href="//{{ website }}" class="text-blue" target="_blank">
                  {{ website }}
                </a>
              </div>
            </div>
          </div>

          <div class="row mb-1 mb-lg-2" *ngIf="profile.email">
            <div class="col-auto pr-0">
              <i class="fas fa-at"></i>
            </div>
            <div class="col">
              <div>
                <a
                  href="mailto:{{ profile.email }}"
                  class="text-blue"
                  target="_blank"
                >
                  {{ profile.email }}
                </a>
              </div>
            </div>
          </div>

          <div class="d-none d-lg-flex gap-1 align-items-center">
            <h6 class="font-weight-normal mb-0">Contactános</h6>
            <a
              href="tel:{{ profile.cellphones[0] }}"
              class="btn px-2 py-1 shadow-sm bg-white text-secondary"
              *ngIf="profile.cellphones?.length > 0"
            >
              <i class="fas fa-phone-alt"></i>
            </a>
            <a
              href="//wa.me/57{{ profile.cellphones[0] }}"
              class="btn px-2 py-1 shadow-sm bg-white text-success"
              target="_blank"
              *ngIf="profile.cellphones?.length > 0"
            >
              <i class="fab fa-whatsapp"></i>
            </a>
            <a
              href="mailto:{{ profile.email }}"
              class="btn px-2 py-1 shadow-sm bg-white text-secondary"
              *ngIf="profile.email"
            >
              <i class="far fa-envelope"></i>
            </a>
          </div>

          <!-- <div
            class="bg-red text-white lh-1 py-2 pl-2 pr-4 position-absolute rounded-left d-none d-lg-block"
            style="right: 0; bottom: 0; width: fit-content"
          >
            Desde:
            <h5 class="mb-0 font-weight-bold">$XXX.XXX.XXX</h5>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- contenido proyectos y filtros -->
<section class="container py-2 mt-2 mt-lg-0">
  <div class="row">
    <!-- filtros -->
    <div class="col-lg-3 pr-lg-0 py-lg-0">
      <button class="btn bg-white rounded-2 d-block mx-auto mx-lg-0" (click)="openFilter()" id="btnFiltros">
        <h5 class="text-red font-weight-bold">
          Filtros <i class="fas "  [class]="openf ? 'fa-times' : 'fa-filter' "></i>
        </h5>
      </button>
      <div class="filtros bg-white rounded-3" [class]="openf ? '' : 'd-none d-lg-block' ">
        <div>
          <ul
            class="nav nav-pills nav-fill mb-3 filter-btns"
            id="filter-btns-vis"
            role="tablist"
          >
            <li class="nav-item" role="presentation">
              <button
                class="btn rounded-2 border text-dark font-weight-bold active btn-sm"
                data-toggle="pill"
                type="button"
                role="tab"
                aria-selected="true"
              >
                Todos
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="btn rounded-3 border text-dark font-weight-bold btn-sm"
                data-toggle="pill"
                type="button"
                role="tab"
                aria-selected="false"
              >
                VIP/VIS
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="btn rounded-3 border text-dark font-weight-bold btn-sm"
                data-toggle="pill"
                type="button"
                role="tab"
                aria-selected="false"
              >
                NO VIS
              </button>
            </li>
          </ul>
        </div>

        <div class="accordion" id="accordionFilters">
          <!-- filtro tipo vivienda -->
          <div class="border-top border-red">
            <button
              class="btn btn-block py-2 d-flex justify-content-between align-items-center font-weight-bold"
              type="button"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Tipo de vivienda <i class="fas"></i>
            </button>

            <div
              id="collapseOne"
              class="collapse show"
              aria-labelledby="headingOne"
            >
              <ul
                class="nav nav-pills nav-fill mb-3 filter-btns"
                id="filter-btns-type"
                role="tablist"
              >
                <li class="nav-item" role="presentation">
                  <button
                    class="btn rounded-2 border text-dark font-weight-bold btn-sm"
                    [class]="filters.apartamento ? 'active' : ''"
                    data-toggle="pill"
                    type="button"
                    (click)="filterBy('apartamento')"
                  >
                    Apartamento
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="btn rounded-3 border text-dark font-weight-bold btn-sm"
                    [class]="filters.casa ? 'active' : ''"
                    data-toggle="pill"
                    type="button"
                    (click)="filterBy('casa')"
                  >
                    Casa
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="btn rounded-3 border text-dark font-weight-bold btn-sm"
                    [class]="filters.apartaestudio ? 'active' : ''"
                    data-toggle="pill"
                    type="button"
                    (click)="filterBy('apartaestudio')"
                  >
                    Apartaestudio
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <!-- filtro ciudad -->
          <div class="border-top border-red">
            <button
              class="btn btn-block py-2 d-flex justify-content-between align-items-center font-weight-bold"
              type="button"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="true"
              aria-controls="collapseTwo"
            >
              Ciudad <i class="fas"></i>
            </button>
            <div
              id="collapseTwo"
              class="collapse show"
              aria-labelledby="headingTwo"
            >
              <div class="px-2 mb-3">
                <select
                  name=""
                  id=""
                  class="form-control rounded-0 border-top-0 border-right-0 border-left-0 border-bottom border-dark mt-0 mb-2"
                  [(ngModel)]="filters.ciudad"
                  (change)="filterByCity($event.target.value)"
                >
                  <option value="null">Seleccione...</option>
                  <option *ngFor="let c of cityList" value="">{{ c }}</option>
                </select>
              </div>
            </div>
          </div>
          <!-- filtro rango de precio -->
          <div class="border-top border-red">
            <button
              class="btn btn-block py-2 d-flex justify-content-between align-items-center font-weight-bold"
              type="button"
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-expanded="true"
              aria-controls="collapseThree"
            >
              Rango de precio <i class="fas"></i>
            </button>

            <div
              id="collapseThree"
              class="collapse show"
              aria-labelledby="headingThree"
            >
              <div class="px-2">
                <div class="row align-items-end">
                  <div class="col pr-0">
                    <input
                      type="text"
                      class="form-control w-100 m-0 rounded"
                      placeholder="Mínimo"
                      [(ngModel)]="filters.maxprice"
                    />
                  </div>
                  <div class="col pr-0">
                    <input
                      type="text"
                      class="form-control w-100 m-0 rounded"
                      placeholder="Máximo"
                      [(ngModel)]="filters.minprice"
                    />
                  </div>
                  <div class="col-auto">
                    <a
                      class="btn btn-red text-white btn-sm"
                      (click)="applyFilters()"
                    >
                      <i class="fas fa-search"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <div class="d-flex align-items-center justify-content-center gap-2">
            <button class="btn border border-red btn-rounded py-1">
              Borrar filtros
            </button>
            <button
              class="btn border border-red btn-red btn-rounded py-1 px-4"
              (click)="applyFilters()"
            >
              Aplicar
            </button>
          </div>
        </div>
      </div>

    </div>

    <!-- lista proyectos -->
    <div class="col-lg-9">
      <div class="py-5 text-center" *ngIf="profile.name && projects?.length == 0">
        Buscando proyectos...
      </div>
      <div class="row mt-md-3 mt-lg-0" *ngIf="profile.name; else loading">
        <div
          class="col-md-6 col-xl-4 pr-lg-0"
          *ngFor="let project of projects; let i = index"
        >
          <a
            [href]="'./constructoras/' + slug + '/proyecto/' + project.slug"
            class="text-dark"
          >
            <div class="card mb-3 overflow-hidden rounded-3 custom-shadow">
              <img
                [src]="
                  project.images[0]?.original ||
                  './assets/img/constructoras/top-default.png'
                "
                [class]="
                  project.images[0]?.original
                    ? 'card-img-top'
                    : 'card-img-top p-5 border-bottom'
                "
                alt=""
                [style]="
                  project.images[0]?.original
                    ? 'background: #fff url(./assets/img/loading-img.gif) center no-repeat;'
                    : ''
                "
              />

              <div class="card-body pt-1 pb-2">
                <div class="row align-items-center">
                  <div class="col-3 pr-0">
                    <div class="text-center">
                      <img
                        [src]="
                          project.logo ||
                          './assets/img/constructoras/top-default.png'
                        "
                        alt=""
                        class="img-fluid"
                      />
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="mb-2">
                      <div
                        class="text-truncate small text-capitalize "
                        title="{{ project.zone }}"
                      >
                        {{ project.zone }}, {{ project.city }}
                      </div>
                      <h6
                        class="text-dark font-weight-bold mb-0 text-truncate"
                        [title]="project.title || 'Proyecto en'"
                      >
                        {{ project.title || "Proyecto en" }}
                      </h6>
                    </div>

                    <div>
                      <div class="text-truncate small">Precio desde:</div>

                      <h6
                        class="text-dark font-weight-bold mb-0 text-truncate"
                        title="Desde ${{ project.currency }}{{
                          project.amount | number
                        }}"
                      >
                        ${{ project.currency }}
                        {{ project.amount | number }}
                      </h6>
                    </div>
                  </div>
                </div>
                <!-- <div class="dropup mb-0 w-100">
                  <button
                    type="button"
                    class="btn btn-blue btn-rounded w-100 font-italic"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-offset="0"
                  >
                    <small> CONTACTAR </small>
                  </button>
                  <div class="dropdown-menu shadow w-100 rounded-3 p-2">
                    <a
                      [href]="
                        profile?.cellphones.length > 0
                          ? 'tel:' + profile?.cellphones[0]
                          : profile?.phone
                          ? 'tel:' + profile?.phone
                          : 'javascript:void(0)'
                      "
                      class="btn text-dark p-0 w-100"
                    >
                      <b><i class="fas fa-phone"></i> Teléfono:</b>
                      {{
                        profile?.cellphones.length > 0
                          ? profile?.cellphones[0]
                          : profile?.phone
                          ? profile?.phone
                          : "No hay información de contacto"
                      }}
                    </a>
                  </div>
                </div> -->
              </div>
              <div
                class="card-footer bg-blue px-2 pb-2 pt-1 text-white text-center"
              >
                <div class="row">
                  <div class="col-4 pr-0 border-right border-white">
                    <div class="small">
                      <small> Área desde </small>
                    </div>
                    <div class="small lh-1">
                      <b> {{ project.area?.area_construida || "XX.XX" }} m<sup>2</sup> </b>
                    </div>
                  </div>
                  <div class="col-4 px-0">
                    <div class="small">
                      <small> Tipo de inmueble </small>
                    </div>
                    <div class="small lh-1">
                      <small>
                        <b>
                          {{ project.type || "Proyecto" }}
                        </b>
                      </small>
                    </div>
                  </div>
                  <div class="col-4 pl-2 border-left border-white">
                    <div class="small">
                      <small>Aplica subsidio</small>
                    </div>
                    <div class="small lh-1">
                      <small>
                        <b>
                          {{ project.vis || "X VIS X" }}
                        </b>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>

      <div class="my-2 text-center" *ngIf="projects?.length > 12">
        <a
          class="btn btn-red-outline btn-rounded px-5 font-weight-bold font-italic"
        >
          <span class="px-4"> CARGAR MÁS RESULTADOS</span>
        </a>
      </div>

      <!-- end content -->
    </div>
  </div>
</section>

<ng-template #loading>
  <div class="emptyBlock p-5 text-center">
    <div class="lds-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-template>
